import React from 'react';
import { NavLink } from "react-router-dom";
import './FloatMenu.css';

//happ-icons 
import { IconIM, IconUser, IconCalendar, IconExamenes } from "happ-components/happ-icons/icons";

const FloatMenu = () => {
    return ( 
        <div className="content-float-menu">
            <div className="page">
                <nav className="page__menu menu">
                    <ul className="menu__list r-list">
                        <li className="menu__group">
                            <NavLink to={"/"} className="content-icons menu-icons">
                                <IconIM />
                            </NavLink>
                        </li>
                        <li className="menu__group">
                            <NavLink to={"/perfil"} className="content-icons menu-icons">
                                <IconUser />
                            </NavLink>
                        </li>
                        <li className="menu__group">
                            <NavLink to={"/mis-examenes"} className="content-icons menu-icons">
                                <IconExamenes />
                            </NavLink>
                        </li>
                        <li className="menu__group">
                            <NavLink to={"/agendas-medicas"} className="content-icons menu-icons">
                                <IconCalendar />
                            </NavLink>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    );
}
 
export default FloatMenu;